import React, { useContext, useEffect } from 'react';
import { useFela } from 'react-fela';
import { Outlet } from 'react-router';

import { ViewContext } from '../context/ViewContext';
import { defaultStyles } from '../utils/constants';
import { useFetchFrontpage } from '../utils/useFetchFrontpage';
import { Box } from './generic/box/box';
import { Col } from './generic/grid/col';
import { Row } from './generic/grid/row';
import { Header } from './Header';

export const Main = () => {
  const { renderer } = useFela();
  const { data } = useContext(ViewContext);
  const theme = data?.settings?.theme;

  const fetchFrontpage = useFetchFrontpage();

  useEffect(() => {
    fetchFrontpage();
  }, [fetchFrontpage]);
  useEffect(() => {
    if (data?.settings?.customCSS) {
      renderer.renderStatic(defaultStyles + data.settings.customCSS);
    }

    const theme = data?.settings?.theme;
    if (theme) {
      [theme?.header?.font, theme?.button?.font, theme?.text?.font].filter(Boolean).forEach((font) => {
        if (font.files) {
          for (const variant of font.variants.map((v) => (v === 'regular' ? '400' : v))) {
            const fontStyle = variant.replace(/[0-9]*/, '');
            const fontWeight = variant.replace(fontStyle, '');
            const options: { fontWeight: string; fontStyle?: string } = { fontWeight };
            if (fontStyle) {
              options.fontStyle = fontStyle;
            }

            renderer.renderFont(font.family, Object.values(font.files), options);
          }
        }
      });
    }
  }, [data]);

  return (
    <Box style={{ ...theme?.text?.style, fontFamily: theme?.text?.font?.family }}>
      <Header />
      <Row>
        <Col xs={10} xsStart={2}>
          <Outlet />
        </Col>
      </Row>
    </Box>
  );
};
